<template>
  <div class="flex items-center justify-center">
    <div
      class="flex aspect-square w-full max-w-sm items-center justify-center overflow-hidden border border-ink/10 bg-white shadow-sm rounded-lg"
      data-testid="player-photo-box"
    >
      <img
        v-if="photo"
        :src="photo"
        :alt="photoAlt"
        class="h-full w-full object-cover"
        loading="lazy"
        data-testid="player-photo-image"
      />
      <div
        v-else
        class="flex h-full w-full items-center justify-center bg-amber-50 text-2xl font-semibold text-neutral-900/70"
        data-testid="player-photo-fallback"
      >
        {{ initials }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useText } from "../composables/useText.js";

const { t } = useText();

const props = defineProps({
  photo: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
});

const photoAlt = computed(() => {
  if (!props.name) return t('common.player-portrait-alt');
  return `${props.name} ${t('common.player-portrait-suffix')}`;
});

const initials = computed(() => {
  const parts = (props.name || "").split(" ").filter(Boolean);
  const value = parts
    .slice(0, 2)
    .map((part) => part[0])
    .join("");
  return (value || "?").toUpperCase();
});
</script>
